import { Filter, FilterConfig, FilterTypes, IsFilterable } from "@/lib/filterable";
import { MrfiktivCreateInsuranceDtoGen, MrfiktivWitnessGen } from "@/services/mrfiktiv/v1/data-contracts";
import { ContactPartial, IContactPartial } from "./contact-partial.entity";

@IsFilterable
class WitnessBase implements MrfiktivWitnessGen {
  /**
   * @inheritdoc
   */
  @FilterConfig({
    type: FilterTypes.STRING,
    displayName: "objects.person.firstName"
  })
  firstName: string;

  /**
   * @inheritdoc
   */
  @FilterConfig({
    type: FilterTypes.STRING,
    displayName: "objects.person.lastName"
  })
  lastName: string;

  /**
   * @inheritdoc
   */
  @FilterConfig({
    type: ContactPartial
  })
  contact: IContactPartial;

  /**
   * @inheritdoc
   */
  role?: "witness" | "responsible" | "victim" | "unclear" | "alternative_driver" | undefined;

  /**
   * @inheritdoc
   */
  imageIds: string[];

  /**
   * @inheritdoc
   */
  isInjured?: boolean | undefined;

  /**
   * @inheritdoc
   */
  note?: string | undefined;

  /**
   * @inheritdoc
   */
  numberplate?: string | undefined;

  /**
   * @inheritdoc
   */
  insurances?: MrfiktivCreateInsuranceDtoGen[] | undefined;

  constructor(witness?: Partial<MrfiktivWitnessGen>) {
    this.firstName = witness?.firstName ?? "";
    this.lastName = witness?.lastName ?? "";
    this.contact = new ContactPartial(witness?.contact);
    this.role = witness?.role;
    this.imageIds = witness?.imageIds ?? [];
    this.isInjured = witness?.isInjured;
    this.note = witness?.note;
    this.numberplate = witness?.numberplate;
    this.insurances = witness?.insurances;
  }

  get dto(): MrfiktivWitnessGen {
    return {
      firstName: this.firstName,
      lastName: this.lastName,
      contact: this.contact.dto,
      role: this.role,
      imageIds: this.imageIds,
      isInjured: this.isInjured,
      note: this.note,
      numberplate: this.numberplate,
      insurances: this.insurances
    };
  }
}

type IWitness = WitnessBase;
const Witness = Filter.createForClass(WitnessBase);

export { IWitness, Witness };
